/* eslint-disable jsx-a11y/aria-role */
import React from 'react';
import {
  Direction,
  Column,
  TextSmall,
  InputToggle
} from '@scotia/canvas-react';
import PropTypes from 'prop-types';
import styles from './ProductsHeader.scss';

const toggleEnabled = ({ showInputToggle, error, allSummariesClosed }) =>
  showInputToggle && !error && !allSummariesClosed;

const ProductsHeader = props => (
  <div
    ref={props.reference}
    className={styles['product-header-title']}
    role={`${props.product}_list-header`}
  >
    <Direction type="row">
      <Column
        md={!toggleEnabled(props) ? 12 : 6}
        xs={!toggleEnabled(props) ? 12 : 7}
        sm={!toggleEnabled(props) ? 12 : 7}
        lg={!toggleEnabled(props) ? 12 : 7}
        className={styles['product-header-continer-title']}
        onClick={props.onClick}
      >
        <TextSmall
          className={`${styles['product-header-title']} ${'text--bold'}`}
        >
          {props.product}
        </TextSmall>
      </Column>
      {toggleEnabled(props) && (
        <Column
          md={6}
          xs={5}
          sm={5}
          lg={5}
          style={{ marginTop: '-6px', zIndex: '7' }}
          className={`${
            styles['product-header-toggle']
          } ${'hide--xs hide--sm'}`}
        >
          <div>
            <InputToggle
              id="setting1"
              name="first setting"
              checked={props.showSald}
              style={{ zIndex: 8 }}
              label={
                <TextSmall className="text--roman">
                  {props.showSald ? 'Saldos visibles' : 'Saldos ocultos'}
                </TextSmall>
              }
              onChange={() => props.onHideSaldHandler()}
            />
          </div>
        </Column>
      )}
    </Direction>
  </div>
);

ProductsHeader.propTypes = {
  showInputToggle: PropTypes.bool,
  showSald: PropTypes.bool,
  product: PropTypes.string.isRequired
};

ProductsHeader.defaultProps = {
  showInputToggle: false,
  showSald: true
};

export default ProductsHeader;
